const blueGrey300Color = '#6B7F89';

export default blueGrey300Color;
